import api from "../../api";
export default {
  inventoryGet(params) {
    return api.get(`/inventory/` + params.url, { params });
  },
};
